import { useNavigate } from "react-router-dom";
import fetchData from "../../APIsControll/apiControll";
import Button from "../../components/updatedComponents/Dealers/Button";
import styles from "../dashboard/Dispatch.module.css";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import { CancelIcon2 } from "../../components/icons/Icon";
import { CloseIcon, TemplateDone } from "../../components/icons/Icon2";

const HandleCancelOrderRequest = ({
  mode,
  managerId,
  orderId,
  closeModal,
  warehouseId,
}) => {
  const navigate = useNavigate();
  const { show } = useToast();
  
  const apiData = {
    managerId: managerId,
    orderId: orderId,
    warehouseId: warehouseId,
  };

  // console.log("warehouse ", warehouse);

  const approveOrderCancelRequest = async () => {
    try {
      const res = await fetchData("dispatch/cancelOrderApproved", apiData);
      if (res.status === "success") {
        navigate("/dispatch");
        show(res.msg, "success");
        closeModal();
      }
      if (res.status === "failed") {
        show(res.msg, "error");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const denyOrderCancelRequest = async () => {
    try {
      const res = await fetchData("dispatch/canceleOrderDeny", apiData);
      if (res.status === "success") {
        navigate("/dispatch");
        show(res.msg, "success");
        closeModal();
      }
      if (res.status === "failed") {
        show(res.msg, "error");
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div
      className={styles.accept_order}
      style={{ backgroundColor: mode ? "#232529" : "#fff" }}
    >
      <div className={styles.header}>
        <p style={{ color: mode && "#FFFFFF" }}>Order Cancel Request</p>
        <div onClick={closeModal}>
          <CloseIcon mode={mode} />
        </div>
      </div>

      <img src="/assets/updatedAssets/logout_img.png" alt="question_icon" />

      <p
        className={`${styles.light_text}`}
        style={{ color: mode ? "#ffffff" : "#000" }}
      >
        This order has been requested to <span>cancel!</span>
      </p>

      <p
        className={`${styles.bold_text}`}
        style={{ color: mode ? "#ffffff" : "#000" }}
      >
        How do you wish to proceed?
      </p>

      <div className={styles.bottom_buttons}>
        <Button
          buttonIcon={<CancelIcon2 />}
          buttonText={"Deny Request"}
          buttonBgColor={"#000000"}
          buttonTextColor={"#ffffff"}
          buttonBorder={"none"}
          buttonClick={denyOrderCancelRequest}
        />
        <Button
          buttonIcon={<TemplateDone />}
          buttonText={"Approve Request"}
          buttonBgColor={"#F93E3E"}
          buttonTextColor={"#ffffff"}
          buttonBorder={"none"}
          buttonClick={approveOrderCancelRequest}
        />
      </div>
    </div>
  );
};

export default HandleCancelOrderRequest;
